import { GraphqlQueryResponse } from "@/Common/api/types/GraphqlQueryResponse";
import { errorLogger } from "@/Common/helpers/logger";
import { IUser } from "@/Common/interfaces/user";
import { apiInstance, gql } from "@/services/httpAdapter";

export async function updateUser(id: string | undefined, locationId: string | undefined, userObject: IUser) {
	const query = gql`
		mutation updateUser($_id: ID!, $locationId: String!, $input: UserInput) {
			updateUser(_id: $_id, locationId: $locationId, input: $input) {
				_id
				username
				locationId
				employeeId
				fullName
				position
				communications {
					acceptsTxt
					communicationType
					usage
					value
				}
				supervisor {
					_id
					fullName
				}
				preferences {
					landingPage
					landingLocation
				}
				profilePicture
				dashboardLayout {
					w
					h
					x
					y
					i
					moved
					static
					isResizable
				}
				kmsUserId
			}
		}
	`;

	const variables = {
		locationId,
		_id: id,
		input: userObject,
	};

	try {
		const response: GraphqlQueryResponse<"updateUser", IUser> = await apiInstance.post("/graphql", {
			query,
			variables,
		});
		return response.data.data?.updateUser;
	} catch (err) {
		errorLogger(err as Error, { function: "updateUser", message: "Failed to update user." });
		return null;
	}
}
